import React from "react";
import { Tabs, Table, Space } from "antd";
import { Job, JobStatus } from "api/Reviews";
import { JobsTabStatusKey } from "../hooks/useJobsData";
import { TABS_CONFIG, TABLE_CONFIG } from "../config";

const { TabPane } = Tabs;

interface JobsTabsProps {
  jobStatus: JobStatus;
  activeTabKey: string;
  onTabChange: (key: string) => void;
  jobsList: Job[];
  jobsListTotal: number;
  jobsListLoading: boolean;
  currentPage: number;
  onPageChange: (page: number) => void;
  activeTabStatusKey: JobsTabStatusKey;
  waitingJobsColumns: any[];
  delayedJobsColumns: any[];
  completedJobsColumns: any[];
}

export const JobsTabs: React.FC<JobsTabsProps> = ({
  jobStatus,
  activeTabKey,
  onTabChange,
  jobsList,
  jobsListTotal,
  jobsListLoading,
  currentPage,
  onPageChange,
  activeTabStatusKey,
  waitingJobsColumns,
  delayedJobsColumns,
  completedJobsColumns,
}) => {
  const columns =
    activeTabStatusKey === "waiting" || activeTabStatusKey === "active"
      ? waitingJobsColumns
      : activeTabStatusKey === "delayed"
      ? delayedJobsColumns
      : completedJobsColumns;

  return (
    <Tabs
      activeKey={activeTabKey}
      onChange={onTabChange}
      style={{ marginTop: 16 }}
    >
      {TABS_CONFIG.map((tabConfig) => (
        <TabPane
          key={tabConfig.key}
          tab={
            <Space>
              <tabConfig.icon {...(tabConfig.iconProps || {})} />
              <span>
                {tabConfig.label} ({jobStatus[tabConfig.statusKey]})
              </span>
            </Space>
          }
        >
          <Table
            dataSource={tabConfig.key === activeTabKey ? jobsList : []}
            columns={columns}
            {...TABLE_CONFIG}
            loading={jobsListLoading}
            pagination={{
              ...TABLE_CONFIG.pagination,
              current: currentPage,
              total: jobsListTotal,
              showSizeChanger: false,
              onChange: onPageChange,
            }}
          />
        </TabPane>
      ))}
    </Tabs>
  );
};
